var map = {
	"./assets/font/iconfont": "qGOr",
	"./assets/font/iconfont.css": "/wAz",
	"./assets/font/iconfont.eot": "idqu",
	"./assets/font/iconfont.js": "qGOr",
	"./assets/font/iconfont.svg": "aLYp",
	"./assets/font/iconfont.ttf": "Y7Kj",
	"./assets/font/iconfont.woff": "ch8d",
	"./assets/font/iconfont.woff2": "+5oa",
	"./assets/img/banners/banner1.png": "DGxO",
	"./assets/img/banners/banner2.png": "CEWp",
	"./assets/img/banners/banner3.png": "okGc",
	"./assets/img/banners/banner4.png": "pSIB",
	"./assets/img/banners/banner5.png": "z4Ej",
	"./assets/img/banners_new/banner0.png": "s2TI",
	"./assets/img/banners_new/banner1.png": "k1lG",
	"./assets/img/banners_new/banner2.png": "CpB5",
	"./assets/img/banners_new/banner3.png": "6D4v",
	"./assets/img/banners_new/banner4.png": "C3YM",
	"./assets/img/banners_new/banner5.png": "5VG8",
	"./assets/img/coorperation/case1.png": "dNWA",
	"./assets/img/coorperation/case1con.png": "YknB",
	"./assets/img/coorperation/case2.png": "OM4o",
	"./assets/img/coorperation/case2icon.png": "1Pbh",
	"./assets/img/coorperation/case3.png": "P/qO",
	"./assets/img/coorperation/case3icon.png": "xxRD",
	"./assets/img/coorperation/case4.png": "eTsC",
	"./assets/img/coorperation/case4icon.png": "iuR7",
	"./assets/img/coorperation/case5.png": "YYTQ",
	"./assets/img/coorperation/case5icon.png": "qBZm",
	"./assets/img/focus/bilibili.png": "JfSh",
	"./assets/img/focus/qr_bilibili.png": "0sD5",
	"./assets/img/focus/qr_weibo.png": "tQNt",
	"./assets/img/focus/qr_weixin.png": "wpFM",
	"./assets/img/focus/weibo.png": "ZoQs",
	"./assets/img/focus/weixin.svg": "U7ru",
	"./assets/img/index/app1.jpg": "w3y5",
	"./assets/img/index/app2.jpg": "eJH1",
	"./assets/img/index/bigData.webp": "hizR",
	"./assets/img/index/cloud.webp": "QxZO",
	"./assets/img/index/internet.webp": "Ab42",
	"./assets/img/index/logo.png": "hP3W",
	"./assets/img/index/logoColor.png": "juU0",
	"./assets/img/index/media.webp": "Jl73",
	"./assets/img/index/service1.png": "aVkW",
	"./assets/img/index/service2.png": "Kln+",
	"./assets/img/index/system1.jpg": "cIbO",
	"./assets/img/index/system2.jpg": "ROLt",
	"./assets/img/logo/logo_color.png": "eYLD",
	"./assets/img/logo/logo_color_all.png": "EZGz",
	"./assets/img/logo/logo_color_font.png": "CuME",
	"./assets/img/logo/logo_white_all.png": "eiRX",
	"./assets/img/logo/logo_white_font.png": "IJp3",
	"./assets/img/logo/logo_wihte.png": "yuPJ",
	"./assets/img/logo/xn_logo.png": "/uBp",
	"./assets/img/logo/xn_logo_color.png": "wIA4",
	"./assets/img/members/group.png": "p8xB",
	"./assets/img/members/group0.png": "H1hv",
	"./assets/img/members/博士_2022_刘美_liumei@nwafu.edu.cn.jpg": "Ckez",
	"./assets/img/members/博士_2022_张尚昆_kern@nwafu.edu.cn.jpg": "9DbH",
	"./assets/img/members/博士_2022_韩旭_hanxu1996@nwafu.edu.cn.jpg": "2DB+",
	"./assets/img/members/博士_2023_徐仁乐_renlexu@nwafu.edu.cn.jpg": "ohUo",
	"./assets/img/members/博士_2023_王启凡_1316606229@qq.com.jpg": "QFal",
	"./assets/img/members/李健导师.png": "yuvt",
	"./assets/img/members/硕士_2021_谷世豪_gshao_907@nwafu.edu.cn.jpg": "8zh4",
	"./assets/img/members/硕士_2022_娄宇航_louyuhang@nwafu.edu.cn.jpg": "TSoV",
	"./assets/img/members/硕士_2022_孔玥_ky2022055668@nwafu.edu.cn.jpg": "svh0",
	"./assets/img/members/硕士_2023_乔雨晴_yqdveoo@126.com.jpg": "j+CH",
	"./assets/img/members/硕士_2023_吴佳盈_wujiaying1201@163.com.jpg": "pecJ",
	"./assets/img/news/1.jpg": "W1OA",
	"./assets/img/news/2.jpg": "yyVi",
	"./assets/img/news/3.jpg": "8nuo",
	"./assets/img/news/4.jpg": "sjO0",
	"./assets/img/news/5.jpg": "VPIH",
	"./assets/img/news_old/bg_02.jpg": "5xSe",
	"./assets/img/news_old/newsCard01.jpeg": "eOxQ",
	"./assets/img/news_old/newsbanner.jpg": "85l/",
	"./assets/img/option/close.png": "jir0",
	"./assets/img/option/menu.png": "VSQt",
	"./assets/img/option/search_icon.png": "ek45",
	"./assets/img/photos/1.jpg": "wtJy",
	"./assets/img/photos/2.jpg": "u3CD",
	"./assets/img/photos/3.jpg": "oyHP",
	"./assets/img/photos/4.jpg": "wQ5n",
	"./assets/img/photos_old/1.jpg": "CgFs",
	"./assets/img/photos_old/2.jpg": "+i8o",
	"./assets/img/photos_old/3.jpg": "uYFk",
	"./assets/img/photos_old/4.jpg": "YRH7",
	"./assets/img/position_map.png": "ggVW",
	"./assets/img/publication/2016-01.png": "AHIc",
	"./assets/img/publication/2018-01.png": "jM95",
	"./assets/img/publication/2018-02.png": "RIlK",
	"./assets/img/publication/2019-01.png": "682P",
	"./assets/img/publication/2019-04.png": "otq3",
	"./assets/img/publication/2020-01.png": "uCuO",
	"./assets/img/publication/2020-02.png": "CmhU",
	"./assets/img/publication/2021-01.png": "Lqil",
	"./assets/img/publication/2022-01.png": "RSL7",
	"./assets/img/publication/2022-02.png": "r8u6",
	"./assets/img/publication/2023-01.png": "xCQS",
	"./assets/img/publication/2023-02.png": "qvcy",
	"./assets/img/research/research0.png": "/LPc",
	"./assets/img/research/research1.png": "dSN7",
	"./assets/img/research/research2.png": "R36B",
	"./assets/img/research/research3.png": "HhaA",
	"./assets/img/users/chatgpt.png": "QnG+",
	"./assets/img/users/visitor.png": "CibP",
	"./assets/logo.png": "7Otq",
	"./assets/style/base.css": "1w+M",
	"./assets/style/common.css": "+KzP",
	"./assets/style/index.css": "1AEq",
	"./assets/style/page.css": "v2C8",
	"./assets/style/variable.less": "wmzT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ycmV";


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/assets.*$
// module id = ycmV
// module chunks = 6